// A11Y-350: ajustes de accesibilidad
import { Component, Output, EventEmitter, ChangeDetectionStrategy, Inject, HostListener, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ApiError } from '@api/models';
import { CUSTOMER_SUPPORT, CustomerSupport, customerSupport } from '@core/constants/info.constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ErrorModalComponent implements AfterViewInit {
  @Output() hide = new EventEmitter<void>();
  @ViewChild('errorActionButton') errorActionButton: ElementRef;
  error: ApiError;

  constructor(private modalRef: BsModalRef, private translateService: TranslateService, @Inject(CUSTOMER_SUPPORT) public customerSupport: CustomerSupport ) {}

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    this.emitHide();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.errorActionButton) {
        this.errorActionButton.nativeElement.focus();
      }
    }, 100);
  }

  emitHide() {
    this.hide.emit();
    this.modalRef.hide();
  }

  handleTranslate(tagTranslate: string) {
    let valueTag = this.translateService.instant(tagTranslate);

    if (valueTag && !valueTag.startsWith('Errors.')) {
      return valueTag;
    }

    const errorMessage =
      this.error && (this.error.message || (this.error as any).errorMessage)
        ? this.error.message || (this.error as any).errorMessage
        : '';

    if (errorMessage) {
      if ((errorMessage.startsWith('401 Unauthorized') && errorMessage.includes('exceptionId')) || this.error?.errorCode === 'auth_error_bad_request') {
        return 'Usuario o contraseña incorrecta';
      } else {
        valueTag = this.translateService.instant('Error.generic');
      }
    } else {
      valueTag = this.translateService.instant('Error.undefined', this.customerSupport);
    }

    return valueTag;
  }


}
